import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import StoreMediaTableView from './StoreMediaTableView';

const StoreContentView = () => {
  const {} = useContext(StoreContext);

  return (
    <Routes>
      <Route element={<StoreMediaTableView />} path="/media" />
      <Route
        element={<Navigate replace to="/merchant/content/media" />}
        path="*"
      />
    </Routes>
  );
};

export default StoreContentView;
